var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerIcon01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st202{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Garage"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st202",
    d: "M296,152h-80c-11,0-20-9-20-20s9-20,20-20h80c11,0,20,9,20,20S307,152,296,152z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st202",
    d: "M392,412c0-27.5-18.6-50.7-43.8-57.8l-9.2-36.8c-6.7-26.8-30.6-45.4-58.2-45.4h-49.5 c-27.6,0-51.5,18.7-58.2,45.4l-9.2,36.8c-25.2,7.1-43.8,30.3-43.8,57.8c0,26.1,16.7,48.3,40,56.6V492c0,11,9,20,20,20s20-9,20-20 v-20h112v20c0,11,9,20,20,20s20-9,20-20v-23.4C375.3,460.3,392,438.1,392,412z M231.2,312h49.5c9.2,0,17.2,6.2,19.4,15.1l6.2,24.9 H205.6l6.2-24.9C214.1,318.2,222,312,231.2,312L231.2,312z M332,432H180c-11,0-20-9-20-20s9-20,20-20h151.9c0,0,0.1,0,0.1,0 c0,0,0,0,0.1,0c11,0,19.9,9,19.9,20C352,423,343,432,332,432L332,432z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st202",
    d: "M474.3,84.3l-195.9-80c0,0-0.1,0-0.1-0.1C271.2,1.4,263.7,0,256,0s-15.2,1.4-22.3,4.3c0,0-0.1,0-0.1,0.1 l-195.9,80C14.8,93.5,0,115.3,0,140v32c0,26.1,16.7,48.3,40,56.6V452c0,33.1,26.9,60,60,60c11,0,20-9,20-20s-9-20-20-20 c-11,0-20-9-20-20V232h352v220c0,11-9,20-20,20c-11,0-20,9-20,20s9,20,20,20c33.1,0,60-26.9,60-60V228.6c23.3-8.3,40-30.5,40-56.6 v-32C512,115.3,497.2,93.5,474.3,84.3z M472,172c0,11-9,20-20,20H60c-11,0-20-9-20-20v-32c0-8.2,4.9-15.5,12.6-18.6 c0,0,0.1,0,0.1-0.1l195.9-80c4.7-1.9,10.1-1.9,14.7,0l195.9,80c0,0,0.1,0,0.1,0.1c7.6,3.1,12.6,10.4,12.6,18.6L472,172z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerIcon01);
export default __webpack_public_path__ + "static/media/customer-icon-01.9f04904fec6db27dc947a0213260cc14.svg";
export { ForwardRef as ReactComponent };